module.exports = "/_next/static/images/top-2ce817bc95bcdc7b4e09207ae6a64f16.jpeg";